import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
    ListMcpConnectionsResponseSchema,
    RevokeMcpConnectionResponseSchema,
} from '../schemas/mcp';
import { defaultErrorResponses } from './errors';

const c = initContract()

/**
 * Account-side MCP assistant-connection management contract (#525, epic #524).
 *
 * These are NORMAL ts-rest endpoints protected by the existing authMiddleware
 * (Supabase browser session) - they let a signed-in user view and unlink their
 * assistant connections from Account settings. They are entirely separate
 * from the resource-bound MCP token surface (`/mcp`, native Express): unlinking
 * here stops future MCP tool calls and never touches the user's Gmail OAuth.
 */
export const mcpContract = c.router({
  listConnections: {
    method: 'GET',
    path: '/v1/mcp/connections',
    responses: {
      200: ListMcpConnectionsResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'List linked assistant connections',
      description:
        "Returns the caller's active (non-revoked) assistant links with provider, connected date, scopes, and last-used. Never returns tokens.",
    },
  },
  revokeConnection: {
    method: 'POST',
    path: '/v1/mcp/connections/:id/revoke',
    pathParams: z.object({ id: z.string().uuid() }),
    body: z.object({}).optional(),
    responses: {
      200: RevokeMcpConnectionResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: true,
      summary: 'Unlink an assistant connection',
      description:
        'Soft-revokes one assistant link so future MCP tool calls are rejected. Idempotent (revoked_count=0 when already gone). Does not disconnect Gmail.',
    },
  },
})
